import { h } from "@stencil/core";
import { TableCellProps } from "../table-cell";

export const renderDate = ({ item, columnKey, translate }: TableCellProps) => (
    <td data-sort={item[columnKey]} data-testid={columnKey}>
        <ux-date-time
            utc={item[columnKey]}
            format={translate(`${columnKey}.dateFormat`)}
        ></ux-date-time>
    </td>
);
